export default "assets/images/logo-cocktails-6a10205a.png";